<template>
  <span class="fa" v-bind:class="{'fa-check': ok}"></span>
</template>
<script>
  export default {
    props: {
      ok: {
        type: Boolean,
        default () {
          return false;
        }
      }
    }
  }
</script>
<style scoped>
  .fa-check {
  color: green;
  }
</style>



// WEBPACK FOOTER //
// YesNo.vue?23ccfb2b